
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { handleGoogleSignIn } from "@/components/auth/AuthHandler";
import { safeRemoveItem, safeSetItem } from "@/utils/storage";
import { supabase } from "@/lib/supabase";

interface AuthFlowProps {
  pendingMeeting: {
    dateTime: Date | null;
    attendeeName: string | null;
    duration?: number;
  } | null;
  prompt: string;
  onSignOut: () => void;
  setIsLoading: (value: boolean) => void;
}

export const AuthFlow = ({ 
  pendingMeeting,
  prompt,
  onSignOut,
  setIsLoading
}: AuthFlowProps) => {
  const { toast } = useToast();

  const handleGoogleSignInClick = () => {
    console.log("Initiating Google Sign In from AuthFlow");
    if (pendingMeeting) {
      console.log("Saving prompt before auth:", prompt);
      if (safeSetItem('pendingMeetingPrompt', prompt)) {
        console.log("Successfully saved prompt to localStorage");
        setIsLoading(true);
        handleGoogleSignIn({
          prompt,
          setIsLoading,
          safeSetItem,
          safeRemoveItem,
          toast
        });
      } else {
        console.error("Failed to save prompt to localStorage");
        toast({
          title: "Error",
          description: "Failed to save meeting details. Please try again.",
          variant: "destructive",
        });
      }
    } else {
      console.error("No pending meeting found");
      toast({
        title: "Error",
        description: "Please enter meeting details first.",
        variant: "destructive",
      });
    }
  };

  const handleSignOut = async () => {
    try {
      safeRemoveItem('pendingMeetingPrompt');
      await supabase.auth.signOut();
      onSignOut();
    } catch (error) {
      console.error('Error signing out:', error);
      toast({
        title: "Error",
        description: "Failed to sign out. Please try again.",
        variant: "destructive",
      });
    }
  };

  return { handleGoogleSignInClick, handleSignOut };
};
